import { render } from "./SegmentedSwitch.vue?vue&type=template&id=6250f384&scoped=true"
import script from "./SegmentedSwitch.vue?vue&type=script&lang=js"
export * from "./SegmentedSwitch.vue?vue&type=script&lang=js"

import "./SegmentedSwitch.vue?vue&type=style&index=0&id=6250f384&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6250f384"]])

export default __exports__